module.exports = __webpack_public_path__ + "static/media/educator_screenshot.bdf4ca83.png";